import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from '../axios';

const useEditSeller = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (params) => {
      const response = await axios.put(
        "/api/sellerprofile/bop",
        {
          first_name: params.first_name,
          surname: params.surname,
          city: params.city,
          postcode: params.postcode,
          address: params.address,
          email_address: params.email_address,
          contact_number: params.contact_number,
          commission: params.commission,
          rejected_item_action: params.rejected_item_action,
          charity: params.donate_to_charity,
        },
        {
          params: {
            _id: params._id
          },
        }
      );
      return response.data;
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ["seller"] });
      queryClient.invalidateQueries({ queryKey: ["seller-2"] });
      queryClient.invalidateQueries({ queryKey: ["sellers"] });
      queryClient.invalidateQueries({ queryKey: ["sellers-2"] });
      queryClient.invalidateQueries({ queryKey: ["sellers-3"] });
    },
    onError: (error) => {
      console.error("Mutation error:", error?.response?.data || error.message);
    }
  });
};

export default useEditSeller;
